import { configureStore } from "@reduxjs/toolkit";
import {
  UserCurrentStateReducer,
  MessagesReducer,
  BasicInformationReducer,
  StepperReducer,
  PersonalInformationReducer,
  DocumentsInformationReducer,
  DemandsInformationReducer,
  FamilyInformationReducer,
  FinancialInformationReducer,
  EducationInformationReducer,
  SearchFiltersReducer,
  DashboardMessagesReducer,
  PageTitleReducer,
  SearchResultReducer,
  LoadingReducer,
} from "../slice";

export default configureStore({
  reducer: {
    UserCurrentState: UserCurrentStateReducer,
    Messages: MessagesReducer,
    BasicInformation: BasicInformationReducer,
    DocumentsInformation: DocumentsInformationReducer,
    DemandsInformation: DemandsInformationReducer,
    EducationInformation: EducationInformationReducer,
    FamilyInformation: FamilyInformationReducer,
    FinancialInformation: FinancialInformationReducer,
    Stepper: StepperReducer,
    PersonalInformation: PersonalInformationReducer,
    SearchFilters: SearchFiltersReducer,
    DashboardMessages: DashboardMessagesReducer,
    PageTitle: PageTitleReducer,
    SearchResult: SearchResultReducer,
    Loading: LoadingReducer,
  },
});
